import React from 'react';
//
import { FormInputProps } from '../../componets/form/formInterfaces';
import FormComplete from '../../componets/form/formComplete';
import { ImperativeHandleAccessedByParentComponent } from '../../componets/interfaces/formProps';

interface IFormInput {
    description: string;
}

const defaultValues = {};

const Form: React.FC<{ settings: any }> = props => {
    const { settings } = props;

    const refForm =
        React.useRef<ImperativeHandleAccessedByParentComponent<IFormInput>>(
            null,
        );

    const inputsForm: FormInputProps<IFormInput>[] = [
        {
            typeInput: 'text',
            name: 'description',
            control: null,
            label: 'Descrição',
            loadingAutocomplete: false,
            md: 3,
            xs: 12,
            rules: {
                required: true,
            },
            messagesError: [
                {
                    type: 'required',
                    message: 'O campo descrição é obrigatório',
                },
            ],
        },
    ];

    return (
        <FormComplete
            defaultValues={defaultValues}
            inputsForm={[...inputsForm]}
            ref={refForm}
            settings={settings}
        />
    );
};

export default Form;
